import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import dayjs from "dayjs";
import { DatePicker } from 'antd';

import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminSiteInfo(props) {
    const formsiteRef = useRef(null)

    const [sitelist, setSiteList] = useState([]);
    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));
    const [siteitem, setSiteitem] = useState({
        sitename_en: '',
        sitename_th: '',
        siteaddress: '',
        siteaddress_sm: '',
        sitecode_no: 0,
        sitecode_txt: '',
        billing_customer: '',
        billing_address: '',
        capacity: 0,
        factor_area: 0,
        factor_stc: 0,
        cod_date: dayjs(new Date()),
        contract_discount_1: 0,
        contract_discount_2: 0,
        business: '',
        contract_irr: 0,
        shutdown_enable: false,
        gps_xy: '',
        tariff_type: 'mea-422',
        tariff_txt: 'mea-422',
        base_tariff: 0
    });

    const [modal_sites, setModal_sites] = useState(false)
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    const onCalendaraChange = (date, dateString) => {
        setSiteitem({
            ...siteitem,
            cod_date: date
        })
        setReportdate_dt(date)
    };

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {

    }

    function init_item() {
        setSiteitem({
            sitename_en: '',
            sitename_th: '',
            siteaddress: '',
            siteaddress_sm: '',
            sitecode_no: 0,
            sitecode_txt: '',
            billing_customer: '',
            billing_address: '',
            capacity: 0,
            factor_area: 0,
            factor_stc: 0,
            cod_date: dayjs(new Date()),
            contract_discount_1: 0,
            contract_discount_2: 0,
            business: '',
            contract_irr: 0,
            shutdown_enable: false,
            gps_xy: '',
            tariff_type: 'mea-422',
            tariff_txt: 'mea-422',
            base_tariff: 0
        })
    }

    useEffect(() => {
        api_load()
        return () => {
            setSiteList([])
        };
    }, []);

    async function api_load() {
        setmodal_load({ enable: true, message: "Loading sites list." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/sites/getdata", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {

                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
                if (response.data.sites !== null && response.data.sites !== undefined) {
                    setSiteList(response.data.sites)
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_edit() {
        var formelement = formsiteRef.current
        formelement.classList.remove("was-validated");
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");

            setmodal_load({ enable: true, message: "Editing sites info in a database." })
            await sleep(500)

            const formData = new FormData();
            formData.append('sitename_en', siteitem.sitename_en)
            formData.append('sitename_th', siteitem.sitename_th)
            formData.append('siteaddress', siteitem.siteaddress)
            formData.append('siteaddress_sm', siteitem.siteaddress_sm)
            formData.append('sitecode_txt', siteitem.sitecode_txt)
            formData.append('billing_customer', siteitem.billing_customer)
            formData.append('billing_address', siteitem.billing_address)
            formData.append('capacity', siteitem.capacity)
            formData.append('factor_area', siteitem.factor_area)
            formData.append('factor_stc', siteitem.factor_stc)
            formData.append('contract_irr', siteitem.contract_irr)
            formData.append('cod_date', dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD"))
            formData.append('contract_discount_1', siteitem.contract_discount_1)
            formData.append('contract_discount_2', siteitem.contract_discount_2)
            formData.append('business', siteitem.business)
            formData.append('shutdown_enable', siteitem.shutdown_enable)
            formData.append('gps_xy', siteitem.gps_xy)
            formData.append('tariff_type', siteitem.tariff_type)
            formData.append('base_tariff', siteitem.base_tariff)

            axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/sites/edit", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_sites(false)
                    init_item()
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your sites info has been edited in a database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        })
                    }
                    if (response.data.sites !== null && response.data.sites !== undefined) {
                        setSiteList(response.data.sites)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    })
                });
        }
    }

    function open_sitehook(data) {
        if (data !== null && data !== undefined) {
            if (data.site_url !== undefined) {
                window.open(data.site_url, "_blank")
            }
        }
    }

    function open_nvrhook(data) {
        if (data !== null && data !== undefined) {
            if (data.nvr_url !== undefined) {
                window.open(data.nvr_url, "_blank")
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <h4 className="mb-1"><i className="fas fa-home"></i> Sites Info</h4>
                            <p className="mb-3">Manage all sites info</p>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" type="button" onClick={() => { api_load() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5>Sites Table (Found {sitelist.length} Sites)</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered  text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>Site Code.</th>
                                        <th>Installation/Tariff Type</th>
                                        <th>Site Name.</th>
                                        <th>INV Shutdown Mode</th>
                                        <th>Business</th>
                                        <th>Capacity (kWp)</th>
                                        <th>Panel Area (m<sup>2</sup>)</th>
                                        <th>Contract Discount</th>
                                        <th>COD Date</th>
                                        <th className="text-center " style={{ width: "100px" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        sitelist?.map((site, index) => (
                                            <tr key={site.sitecode_txt} >
                                                <td className='font-sarabun'>{site.sitecode_txt}</td>
                                                <td className='font-sarabun'>{site.solar_type} <p className='mt-1 mb-0 font-sarabun'>{site.tariff_txt}</p></td>
                                                <td className='font-sarabun' ><div style={{ fontWeight: "600" }}>{site.sitename_th}</div> <p className='mt-1 mb-0 font-sarabun'>{site.siteaddress}</p></td>
                                                <td className='font-sarabun'>{site.shutdown_enable === true ? "Enabled" : "Disabled"}</td>
                                                <td className='font-sarabun'>{site.business}</td>
                                                <td className='font-sarabun'>{site.capacity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                <td className='font-sarabun'>{site.factor_area.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                <td className='font-sarabun'>{site.solar_type === "Rooftop + Floating" ? site.contract_discount_1.toFixed(2) + " / " + site.contract_discount_2.toFixed(2) : site.contract_discount_1.toFixed(2)}</td>
                                                <td className='font-sarabun'>{site.cod_date_only}</td>
                                                <td>
                                                    <Link className="btn btn-icon btn-sm btn-warning btn-hover btn-bordered" title="Edit" onClick={() => {
                                                        setSiteitem(site);
                                                        setModal_sites(true);
                                                        setReportdate_dt(dayjs(new Date(site.cod_date_only)))
                                                    }}><i className="fas fa-pen"></i></Link>
                                                    <Link className="btn btn-icon btn-sm btn-info btn-hover btn-bordered mx-2" title="Site Hook" onClick={() => {
                                                        open_sitehook(site)
                                                    }}><i className="fas fa-network-wired"></i></Link>
                                                    <Link className="btn btn-icon btn-sm btn-info btn-hover btn-bordered me-2" title="NVR Hook" onClick={() => {
                                                        open_nvrhook(site);
                                                    }}><i className="mdi mdi-cctv"></i></Link>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>

                    {
                        modal_sites ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-xl modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-home"></i> Edit Sites Info {siteitem.sitecode_txt}</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_sites(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formsiteRef} className='mt-1 mb-1 mb-md-4' action="" method="POST" encType="multipart/form-data" >
                                                    <div className="row mb-3">
                                                        <h6>Site Information</h6>
                                                        <div className="col-md-6 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="sitename_en">Site Name EN</label>
                                                                <input type="text" className="form-control" name="sitename_en" value={siteitem.sitename_en} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        sitename_en: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="sitename_th">Site Name TH</label>
                                                                <input type="text" className="form-control" name="sitename_th" value={siteitem.sitename_th} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        sitename_th: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="siteaddress">Site Address</label>
                                                                <input type="text" className="form-control" name="siteaddress" value={siteitem.siteaddress} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        siteaddress: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="siteaddress_sm">Site Address Short</label>
                                                                <input type="text" className="form-control" name="siteaddress_sm" value={siteitem.siteaddress_sm} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        siteaddress_sm: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="gps">GPS</label>
                                                                <input type="text" className="form-control" name="gps" value={siteitem.gps_xy} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        gps_xy: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <h6>Billing Info</h6>
                                                        <div className="col-md-5 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="billing_customer">Billing Customer Name</label>
                                                                <input type="text" className="form-control" name="billing_customer" value={siteitem.billing_customer} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        billing_customer: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-7 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="billing_address">Billing Customer Address</label>
                                                                <input type="text" className="form-control" name="billing_address" value={siteitem.billing_address} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        billing_address: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <h6>Site Specification</h6>
                                                        <div className="col-md-3 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="capacity">Capacity (kWp)</label>
                                                                <input type="number" className="form-control" name="capacity" min={1} step={0.01} value={siteitem.capacity} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        capacity: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="factor_area">Panel Area (m<sup>2</sup>)</label>
                                                                <input type="number" className="form-control" name="factor_area" min={1} step={0.01} value={siteitem.factor_area} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        factor_area: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="factor_stc">PV STC Factor</label>
                                                                <input type="number" className="form-control" name="factor_stc" min={0.0001} step={0.0001} value={siteitem.factor_stc} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        factor_stc: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <h6>Parameter of Contract</h6>
                                                        <div className="col-md-3 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="contract_discount_1">Discount of Contract (%) P1</label>
                                                                <input type="number" className="form-control" name="contract_discount_1" min={0.01} max={100} step={0.01} value={siteitem.contract_discount_1} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        contract_discount_1: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="contract_discount_2">Discount of Contract (%) P2</label>
                                                                <input type="number" className="form-control" name="contract_discount_2" min={0} max={100} step={0.01} value={siteitem.contract_discount_2} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        contract_discount_2: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="base_tariff">Base Tariff of Contract (Bath/THB)</label>
                                                                <input type="number" className="form-control" name="base_tariff" min={1.00} max={1000000.00} step={0.01} value={siteitem.base_tariff} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        base_tariff: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="contract_irr">Irradiation of Contract (kWh/m<sup>2</sup> /yr.)</label>
                                                                <input type="number" className="form-control" name="contract_irr" min={1} step={0.01} value={siteitem.contract_irr} onChange={(e) => {
                                                                    setSiteitem({
                                                                        ...siteitem,
                                                                        contract_irr: e.target.value
                                                                    })
                                                                }} required readOnly />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <h6>Other Information & Setting</h6>
                                                        <div className="col-md-3 mb-1">
                                                            <div className="form-group">
                                                                <label htmlFor="cod_date">COD Date</label>
                                                                <DatePicker
                                                                    allowClear={false}
                                                                    className={"form-control"}
                                                                    onChange={onCalendaraChange}
                                                                    style={{
                                                                        fontFamily: "poppins",
                                                                        fontSize: "0.75rem",
                                                                        Color: "black",
                                                                        lineHeight: "1.5",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    value={reportdate_dt}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-1">
                                                            <label htmlFor="shutdown_enable">INV Shutdown Mode</label>
                                                            <select name="shutdown_enable" className="form-select mb-3" value={siteitem.shutdown_enable} onChange={(e) => {
                                                                setSiteitem({
                                                                    ...siteitem,
                                                                    shutdown_enable: e.target.value
                                                                })
                                                            }} required>
                                                                <option value={false}>Disable</option>
                                                                <option value={true}>Enable</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-6 mb-1">
                                                            <label htmlFor="tariff">Type of Tariff</label>
                                                            <select name="tariff" className="form-select mb-3" value={siteitem.tariff_type} onChange={(e) => {
                                                                setSiteitem({
                                                                    ...siteitem,
                                                                    tariff_type: e.target.value
                                                                })
                                                            }} required>
                                                                <option value="">Please select</option>
                                                                <option value={'mea_422'}>MEA 4.2.2 ประเภทที่ 4 กิจการขนาดใหญ่ 12-24 kV</option>
                                                                <option value={'pea_312'}>PEA 3.1.2 ประเภทที่ 3 กิจการขนาดกลาง 22-33 kV</option>
                                                                <option value={'pea_322'}>PEA 3.2.2 ประเภทที่ 3 กิจการขนาดกลาง 22-33 kV</option>
                                                                <option value={'pea_421'}>PEA 4.2.1 ประเภทที่ 4 กิจการขนาดใหญ่ 69 kV ขึ้นไป</option>
                                                                <option value={'pea_422'}>PEA 4.2.2 ประเภทที่ 4 กิจการขนาดใหญ่ 22-33 kV</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_sites(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_edit() }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminSiteInfo